<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-card-text>
        <v-container>
          <div class="font-weight-medium mb-5 black--text" style="font-size: 20px">
            Lengkapi Info Kelas Pelatihan Pengimbasan
          </div>
          <base-form-generator :schema="schema" v-model="form" />
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  components: { BaseFormGenerator },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        placholder: ['-- Pilih Provinsi -- ', '-- Pilih Kota --'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 6 }, { cols: 6 }],
      };
    },

    schema() {
      return [
        {
          type: 'VTextField',
          name: 'nama',
          label: `Nama Kelas`,
          labelColor: 'secondary',
          placeholder: 'Tuilskan nama kelas',
          hint: 'wajib diisi',
          required: true,
          grid: { cols: 12, lg: 6 },
          outlined: true,
          singleLine: true,
          dense: true,
          hideDetails: true,
        },
        {
          type: 'VTextField',
          name: 'lokasi',
          label: `Lokasi Pelatihan`,
          labelColor: 'secondary',
          placeholder: 'Tuilskan lokasi pelatihan',
          grid: { cols: 12, lg: 6 },
          outlined: true,
          singleLine: true,
          dense: true,
          hideDetails: true,
        },
        {
          type: 'VDatePicker',
          name: 'tgl_mulai',
          label: 'Tanggal mulai',
          labelColor: 'info',
          placeholder: 'Pilih tanggal mulai kegiatan',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
        },
        {
          type: 'VDatePicker',
          name: 'tgl_selesai',
          label: 'Tanggal selesai',
          labelColor: 'info',
          placeholder: 'Pilih tanggal selesai kegiatan',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
        },
        {
          type: 'cascade',
          labelColor: 'info',
          hideDetails: true,
          configs: this.configs,
          grid: { cols: 12 },
        },
        {
          type: 'VTextarea',
          name: 'alamat',
          label: 'Alamat Lokasi Pelatihan',
          placeholder: 'Tuliskan alamat lokasi pelatihan',
          grid: { cols: 12 },
          rows: 2,
          autoGrow: true,
          outlined: true,
          dense: true,
          singleLine: true,
          hideDetails: true,
        },
      ];
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      if (!value) return;

      for (const schema of this.schema) {
        if (value[schema.name]) {
          this.$set(this.form, schema.name, value[schema.name] || '');
        }
      }

      this.$set(this.form, 'k_propinsi', value['k_propinsi'] || '');
      this.$set(this.form, 'k_kota', value['k_kota'] || '');
    },

    getValue() {
      return this.form;
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
